// Copyright (c) 2026 Optimum Healthcare IT. All rights reserved.
// Author: Frank Scalzo <Optimum Healthcare IT>
// License: proprietary
// provenance-id: 14ca9bd9-99a3-486e-a7c9-8f928212b8f6

// Runtime configuration (transfer pattern): the SAME build runs in any
// environment because config comes from /config.json fetched at startup, not
// from build-time env vars.
//
//   local dev  -> public/config.json  (authRequired:false, local API)
//   deployed   -> config.json written to S3 at deploy time from SSM values
//                 (authRequired:true, API Gateway URL, Cognito ids)

const FALLBACK = {
  authRequired: false,
  apiUrl: 'http://localhost:4000',
  region: 'us-east-1',
  userPoolId: '',
  userPoolClientId: '',
  stage: 'local',
};

let cfg = null;

export async function loadConfig() {
  if (cfg) return cfg;
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (!res.ok) throw new Error('no config');
    cfg = { ...FALLBACK, ...(await res.json()) };
  } catch (e) {
    cfg = { ...FALLBACK };
  }
  return cfg;
}

export function getConfig() {
  return cfg || FALLBACK;
}
